import {Jwt } from '../@core/jwt/useJwt'


const { jwt } = Jwt({})

export default jwt